import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent implements OnInit {
  public projects: any[] = [];
  public errorMessage: string | null = null;
  activeProject: string | null = null;
  protected currentPage = 1;
  protected search: string = '';
  protected limit: number = 10;
  constructor(private projectService: ProjectService,
    private localStorage: LocalStorageService,
    private commonService: CommonService,
    private route: ActivatedRoute,

  ) { }
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.activeProject = params.get('id');
    });
    this.loadProjects();
  }
  /**
   * Fetches and subscribes to the project list from ProjectService.
   *
   * - On success: Updates the `projects` array for display.
   * - On error: Logs the error and sets `errorMessage` for user notification.
   *
   * Uses ProjectService's BehaviorSubject to keep the project list state in sync.
   */
  private loadProjects() {
    this.projectService.listProjects(this.currentPage, this.limit, this.search);
    this.projectService.projects$.subscribe({
      next: (projects: any[]) => {
        this.projects = projects;
      },
      error: (err: any) => {
        console.error('Error loading projects', err);
        this.errorMessage = 'Failed to load projects.';
      }
    });
  }


  /**
* on click project
* @param{any}project
*/
  onClickProject(project: any): void {
    this.activeProject = project?.project_id?._id;
    this.localStorage.set('projectId', project?.project_id?._id);
    this.commonService.updateSidebarStatus(true);
  }

}
